import { ReactNode } from 'react';
import { CustomerTypeEnum, IdTypeEnum, OpenType } from 'types/customer';

export enum TaxTypeEnum {
    SSN = '1',
    NON_SSN = '0'
}

export interface AccountFormutil {
    customer_type?: CustomerTypeEnum;
    temporary_tax_type?: TaxTypeEnum;
    // 通过特定开户链接的指定开户类型
    temporaryOpenType?: OpenType;
    id_type: IdTypeEnum;
}

export interface AccountOption {
    value: TaxTypeEnum | CustomerTypeEnum;
    title: string;
    description: ReactNode;
}
